// @flow
import React, { Fragment } from 'react';
import type { ProductItem } from 'store/modules/display';
import { Link } from 'react-router-dom';
import { escapeForUrl, resizeImage, numberWithCommas } from 'lib/common';
import './UserProductCard.scss';

type Props = {
  product: ProductItem,
  username: string,
};

const UserProductCard = ({ product, username }: Props) => {
  const {
    title,
    body,
    thumbnail,
    meta,
    tags,
    released_at,
    comments_count,
    url_slug,
    is_private,
  } = product;

  const sliced = (() => {
    const content = meta.short_description || body;
    return content.slice(0, 100) + (content.length > 100 ? '...' : '');
  })();

  const link = `/@${username}/products/${url_slug}`;

  return (
    <div className="UserProductCard">
      <div className="mini-productcard">
        {thumbnail && (
          <Fragment>
            <Link to={link} className="thumbnail">
              <img src={resizeImage(thumbnail, 150, 150)} alt={`${title} Thumbnail`} />
            </Link>
            <div className="separator" />
          </Fragment>
        )}
        <div className="product-info">
          <h4>
            <Link to={link}>{title}</Link>
          </h4>
          {!!(meta.price && meta.price !== '0' && meta.price !== 0) && (
            <div className="price">
              <span>
                {numberWithCommas(meta.price)}
                <span className="price-unit">원</span>
              </span>
            </div>
          )}
          <p>{sliced}</p>
          <div className="tags">
            {tags.map(tag => (
              <Link
                to={`/@${username}/products/tags/${escapeForUrl(tag)}`}
                className="tag"
                key={tag}
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

UserProductCard.Placeholder = () => {
  return (
    <div className="UserProductCard placeholder">
      <div className="mini-productcard">
        <div className="thumbnail">
          <div className="fake-img gray-box" />
        </div>
        <div className="separator" />
        <div className="product-info">
          <h4>
            <span className="gray-box" style={{ width: '60%' }} />
          </h4>
          <p>
            <span className="gray-box" style={{ width: '90%' }} />
            <span className="gray-box" style={{ width: '100%' }} />
            <span className="gray-box" style={{ width: '95%' }} />
          </p>
          <p>
            <span className="gray-box" style={{ width: '20%' }} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserProductCard;



// WEBPACK FOOTER //
// ./src/components/user/UserProductCard/UserProductCard.js